import { render, staticRenderFns } from "./active-call-list.vue?vue&type=template&id=58ee364f&"
import script from "./active-call-list.vue?vue&type=script&lang=js&"
export * from "./active-call-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports